// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const HOME_SUGGEST_ARTICLE_PROMPT = "M\u00e1\u0161 nie\u010do zauj\u00edmav\u00e9, \u010do by sme mohli zaradi\u0165 na tituln\u00fa str\u00e1nku?";
export const HOME_SUGGEST_ARTICLE_SUCCESS = "\u010eakujeme za n\u00e1vrh :-)";
